import React from 'react'
import Svg from 'src/Components/shared/Svg'

const BinocularsHexagon = props => (
  <Svg viewBox='0 0 50 54' width={50} height={54} fill='none' {...props}>
    <g filter='url(#prefix__filter0_d)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M48 36.458l-.248-20.384c-.02-1.65-.942-3.183-2.419-4.025L27.075 1.646c-1.477-.841-3.283-.862-4.741-.055L4.322 11.57A4.466 4.466 0 002 15.542l.247 20.385c.021 1.65.942 3.183 2.419 4.024l18.258 10.404c1.477.841 3.283.862 4.741.055l18.013-9.982A4.466 4.466 0 0048 36.457z'
        fill='#535256'
      />
    </g>
    <path
      d='M23.31 28.215a3.514 3.514 0 001.675.445c.609 0 1.188-.149 1.675-.445.396 3.204 3.228 5.726 6.64 5.726 3.685 0 6.7-2.938 6.7-6.527 0-1.84-.792-3.501-2.04-4.688-.183-.148-.336-.297-.518-.445l-2.528-2.077a6.697 6.697 0 00-3.381-1.187l.122.12-1.523-1.514A2.424 2.424 0 0028.518 17c-1.097.03-2.01.712-2.315 1.661a2.485 2.485 0 00-1.066-.326h-.183c-.426 0-.852.119-1.188.326-.304-.949-1.218-1.602-2.284-1.602-.609 0-1.188.238-1.614.623l-1.523 1.514.122-.12a6.698 6.698 0 00-3.38 1.188l-2.529 2.076c-.182.149-.365.297-.517.445C10.79 23.972 10 25.634 10 27.473 10 31.063 13.015 34 16.7 34c3.381-.06 6.214-2.552 6.61-5.785zm8.984-5.133l.58-.089c.151 0 .273-.03.425-.03 2.528 0 4.569 1.988 4.569 4.45 0 2.463-2.04 4.45-4.569 4.45-2.527 0-4.568-1.987-4.568-4.45 0-2.136 1.523-3.886 3.563-4.331zm-7.31.83c.823 0 1.493.653 1.493 1.454 0 .802-.67 1.454-1.492 1.454-.823 0-1.493-.652-1.493-1.454 0-.8.67-1.453 1.493-1.453zm-8.314 7.952c-2.528 0-4.569-1.988-4.569-4.45 0-2.463 2.041-4.45 4.57-4.45.151 0 .273 0 .425.029l.58.089c2.04.445 3.563 2.225 3.563 4.332 0 2.462-2.041 4.45-4.569 4.45z'
      fill='#BBB2B7'
    />
    <defs>
      <filter
        id='prefix__filter0_d'
        x={0}
        y={0}
        width={50}
        height={54}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
      </filter>
    </defs>
  </Svg>
)

export default BinocularsHexagon
